module.exports = __webpack_public_path__ + "static/media/video_part.1ececdd1.png";